module.exports = (__webpack_require__(0))(4);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/View.js from dll-reference girder_plugin_jobs
// module id = 18
// module chunks = 0